import { render, staticRenderFns } from "./RecebimentoItem.vue?vue&type=template&id=a9aee4c6&scoped=true"
import script from "./RecebimentoItem.vue?vue&type=script&lang=ts"
export * from "./RecebimentoItem.vue?vue&type=script&lang=ts"
import style0 from "./RecebimentoItem.vue?vue&type=style&index=0&id=a9aee4c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aee4c6",
  null
  
)

export default component.exports